// Zero-price lines on Quotation, Sale Order, Sale Invoice and Non-Tax Sale
// Invoice (2026-11-02). They used to be dropped silently on save (only the
// lines with a price were kept). Now they save — free items, samples, bonus
// stock — after one warning that lists them, so a forgotten price is caught.
// Returns true to go on saving, false to go back to the form.
export const confirmZeroPriceLines = (lines, { fbr = false } = {}) => {
  const zero = (lines || []).filter(l => !(Number(l.unitPrice) > 0));
  if (zero.length === 0) return true;
  const names = zero.map(l => `• ${l.itemName || l.description || 'Item'}`).join('\n');
  const fbrNote = fbr ? '\n\nNote: FBR may refuse a zero-value line when this invoice is sent to FBR.' : '';
  // eslint-disable-next-line no-alert
  return window.confirm(`These items have zero price:\n${names}${fbrNote}\n\nSave anyway?`);
};
